import { ERROR_STATUSES } from "../constants/import-customers";
import { ImportRowData } from "../types/ImportRow";

export const isLoading = (row: ImportRowData) => row.status === "IMPORTING";

export const isImportDataError = (row: ImportRowData) => ERROR_STATUSES.includes(row.status);
